export class Allergy {
  allergy_desc?: string;
  firstname?: string;
  allergy_coding_id?: number;
  severity_coding_id?: number;
  reaction_desc?: string;
  version_id?: number;
  reaction_coding_id?: number;
  agent_coding_id?: number;
  sev_desc?: string;
  lastname?: string;
  dt?: string;
  patient_id?: number;
  agent_desc?: string;
  allergy_onset_date?: string;
  status?: number;
  [key: string]: any;
}
